module.exports = ".form-group .checkbox.disabled label {\n  color: #ccc; }\n\n.form-group .checkbox:not(:last-child) {\n  margin-bottom: 18px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extratos/exportacao-movimento/exportacao-movimento.component.scss
// module id = ./src/app/extratos/exportacao-movimento/exportacao-movimento.component.scss
// module chunks = main